export default __webpack_public_path__ + "static/media/NO-MATCH.4c8baa43.png";